import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthHelper } from '@cation/core/auth/auth-helper';
import { LogService } from '@cation/core/services/log/log.service';
import { ThemeService } from '@cation/core/services/theme/theme.service';
import Team from '@cation/core/types/team';
import { faGamepad, faUsers, faTrophy, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-admin-teams-statistics',
  templateUrl: './teams-statistics.component.html',
  styleUrls: ['./teams-statistics.component.scss']
})
export class TeamsStatisticsComponent implements OnInit, OnDestroy {
  public team: Team;
  public isLoading = false;
  public isDark = false;

  // Icons
  public faGamepad = faGamepad;
  public faUsers = faUsers;
  public faTrophy = faTrophy;
  public faChartLine = faChartLine;

  private _onDestroy = new Subject<void>();

  constructor(
    public auth: AuthHelper,
    private logService: LogService,
    private themeService: ThemeService
  ) {}

  async ngOnInit() {
    // Initialize theme
    if (this.auth.userProfile?.cognitoId) {
      this.isDark = this.themeService.isDarkMode(this.auth.userProfile.cognitoId);
    }

    // Watch for theme changes
    this.watchThemeChanges();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  private watchThemeChanges() {
    // Watch for dark-mode class changes on body
    const observer = new MutationObserver(() => {
      if (this.auth.userProfile?.cognitoId) {
        const newIsDark = this.themeService.isDarkMode(this.auth.userProfile.cognitoId);
        if (this.isDark !== newIsDark) {
          this.isDark = newIsDark;
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Clean up observer on destroy
    this._onDestroy.subscribe(() => observer.disconnect());
  }

  async onSelectTeam(selectedTeam) {
    this.logService.log('onSelectTeam', selectedTeam);
    this.team = selectedTeam;
  }
}
